import { CommonModule } from '@angular/common';
import { Component, ViewChild } from '@angular/core';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { InsuranceFlowService } from 'src/app/_services/insurance-flow.service';
import { InsuranceFlowStatus } from 'src/app/enums/insurance-flow/insurance-flow-status.enum';
import { ActionModalComponent } from 'src/app/shared/components/action-modal/action-modal.component';
import { IconsModule } from 'src/app/shared/icons/icons.module';

import { TaskDetailsService } from '../../../../task-details.service';
import { BaseStepperAction } from '../../../task-history/stepper-actions/base-action';

@Component({
  selector: 'app-send-centralisation-action',
  standalone: true,
  imports: [CommonModule, NgbTooltipModule, IconsModule, ActionModalComponent],
  templateUrl: './send-centralisation.component.html',
})
export class SendCentralisationComponent extends BaseStepperAction {
  @ViewChild('actionModal') modal: ActionModalComponent;

  submitted = false;

  get enabled(): boolean {
    return (
      this.state?.insuranceFlowData?.status ===
      InsuranceFlowStatus.PENDING_CENTRALISATION
    );
  }

  constructor(
    taskDetailsService: TaskDetailsService,
    private readonly insuranceFlowService: InsuranceFlowService,
    private readonly toastrService: ToastrService
  ) {
    super(taskDetailsService);
  }

  sendCentralisation() {
    const flowId = this.state?.insuranceFlowData?.id;
    if (this.submitted || !flowId) return;
    this.submitted = true;
    this.insuranceFlowService.sendCentralisationFlow({ flowId }).subscribe({
      next: (res) => {
        if (res.error) {
          this.toastrService.error(
            $localize`Une erreur est survenue. Veuillez réessayer ultérieurement`
          );
        } else {
          this.toastrService.success(
            $localize`Centralisation marquée comme envoyée`
          );
          this.modal?.closeModal();
          this.refreshTaskDetails();
        }
        this.submitted = false;
      },
      error: () => {
        this.toastrService.error(
          $localize`Une erreur est survenue. Veuillez réessayer ultérieurement`
        );
        this.submitted = false;
      },
    });
  }
}
